var _effectorFileName = "/builds/gmini/front-ui-kit/src/Select/components/RenderOption/RenderOption.tsx";
import { HighlightText } from '../../../HighlightText';
import { OptionWrapper } from '../OptionWrapper';
import { jsx as _jsx } from "react/jsx-runtime";
// eslint-disable-next-line @typescript-eslint/ban-types
export const RenderOption = ({
  option,
  active,
  hover,
  onSelect,
  onMouseEnter,
  getOptionLabel,
  isHighlightEnabled,
  highlightingPattern,
  ...other
}) => /*#__PURE__*/_jsx(OptionWrapper, {
  hover: hover,
  onClick: () => onSelect(option),
  onMouseEnter: onMouseEnter,
  active: active,
  ...other,
  children: !isHighlightEnabled ? getOptionLabel(option) : /*#__PURE__*/_jsx(HighlightText, {
    text: getOptionLabel(option),
    pattern: highlightingPattern || ''
  })
});